const config = {
  apiBaseUrl: 'https://eidon-api.newhopechurch.org',
    api4BaseUrl: 'https://eidon-api-next.newhopechurch.org',
  schedulerBaseUrl: 'https://eidon-scheduler.newhopechurch.org',
  liveVideoRefreshCheck: 60000
};

module.exports = config;
